"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));

var _Accordion = _interopRequireDefault(require("../../Accordion"));

var _utils = require("../../utils");

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var TabPane = _FlexTabContainer["default"].TabPane; // eslint-disable-next-line react/display-name

var PictureComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  // let keys;
  var imageSrc = props.imageSrc;

  var _a = (0, _utils.fomateFileData)(imageSrc),
      url = _a.url,
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b;

  var _c = (0, _react.useState)({}),
      styles = _c[0],
      setStyls = _c[1];

  var _d = (0, _react.useState)(0),
      value = _d[0],
      setValue = _d[1];

  var _e = (0, _react.useState)(0),
      ifshow = _e[0],
      setIfshow = _e[1];

  var fWidth;
  var fHeight;
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    var collectStyles = {};

    if (url) {
      imgLoad.src = url;
    }

    imgLoad.onload = function () {
      fWidth = 955 / imgLoad.width;
      fHeight = imgLoad.height * fWidth;

      if (fHeight > 748) {
        setIfshow(1);
        collectStyles = {
          width: '100%',
          maxHeight: '648px'
        };
      } else {
        collectStyles = {
          maxHeight: '2000px',
          width: '100%'
        };
      }

      setStyls(collectStyles);
    };
  }, []); // setStyls(collectStyles);

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'framework-img',
    style: __assign({
      maxWidth: '1152px'
    }, styles)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    ref: ref,
    src: url,
    alt: alt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: ifshow == 1 ? {
      display: 'flex'
    } : {
      display: 'none'
    },
    className: value == 1 ? 'posi-open posi' : 'posi-stop posi',
    onClick: function onClick() {
      var collectStyles;

      if (value == 0) {
        setValue(1);
        collectStyles = {
          width: '100%',
          maxHeight: '2000px'
        };
      } else {
        setValue(0);
        collectStyles = {
          width: '100%',
          maxHeight: '648px'
        };
      }

      setStyls(collectStyles);
    }
  }, value == 0 ? 'Show more' : 'Show less', /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "design-iconfont d-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#006EFF",
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  }))));
});
var Architectrue = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      source = props.source,
      imageSrc = props.imageSrc,
      flexTitle = props.flexTitle,
      style = props.style,
      configuration = props.configuration,
      className = props.className,
      onClick = props.onClick,
      desc = props.desc,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "imageSrc", "flexTitle", "style", "configuration", "className", "onClick", "desc"]); // 判断是否使用的样式类型 -pc or mobile


  var _a = (0, _react.useState)(true),
      currentClass = _a[0],
      setCurrentClass = _a[1];

  var pictureRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-archite-true-container-pc',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-archite-true-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    className: className
  }), currentClass ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: '0 24px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], __assign({
    ref: ref
  }, restProps), configuration ? configuration.map(function (item, i) {
    var _a = item,
        title = _a.title,
        key = _a.key,
        filedVideoBg = _a.filedVideoBg,
        filedVideoList = _a.filedVideoList,
        content = _a.content,
        imageSrc = _a.imageSrc;
    var isShowDescription = content && content !== '<p></p>'; // 过滤富文本空字符

    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: title
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: 'ant-tabs-content-holder__section',
      style: {
        position: 'relative',
        marginTop: configuration.length > 1 ? '24px' : '0'
      }
    }, isShowDescription && /*#__PURE__*/_react["default"].createElement("div", {
      className: 'architecture-article',
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), /*#__PURE__*/_react["default"].createElement(PictureComponent, {
      ref: pictureRef,
      imageSrc: imageSrc,
      filedVideoList: filedVideoList,
      filedVideoBg: filedVideoBg
    })));
  }) : null)) : /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    configuration: configuration
  })));
});
Architectrue.displayName = 'TCIArchitectrue';
var _default = Architectrue;
exports["default"] = _default;